module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [(_vm.productAmount > 1 && _vm.prodType === 'package' && _vm.adjusts.length) ? _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "top": "10px"
    }
  }, [_c('label', {
    staticClass: "text-13 text-black pull-right"
  }, [_c('q-checkbox', {
    model: {
      value: (_vm.adjustSame[_vm.currentProduct[_vm.schema.product.product_id]]),
      callback: function($$v) {
        _vm.$set(_vm.adjustSame, _vm.currentProduct[_vm.schema.product.product_id], $$v)
      },
      expression: "adjustSame[currentProduct[schema.product.product_id]]"
    }
  }), _vm._v("統一口味設定\n      ")], 1)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pAmountShow), function(pA) {
    return _c('ul', {
      staticClass: "col-xs-12 nav"
    }, [(_vm.pAmountShow > 1) ? _c('li', [_c('hr', {
      staticStyle: {
        "border-top": "dashed 1px #eee"
      }
    }), _vm._v(" "), _c('hr', {
      staticStyle: {
        "border-top": "dashed 1px #eee"
      }
    }), _vm._v("\n      " + _vm._s(pA) + ". " + _vm._s(_vm.currentProduct[_vm.schema.product.name]) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('menu-options', {
      ref: 'menu-options-' + _vm.currentProduct[_vm.schema.product.product_id] + '-index' + pA,
      refInFor: true,
      attrs: {
        "storeState": 2,
        "currentProduct": _vm.currentProduct,
        "prodType": "package",
        "checkPrice": _vm.checkPrice,
        "checkAddProduct": _vm.checkAddProduct,
        "checkAddDifProduct": _vm.checkAddDifProduct,
        "productAmount": _vm.productAmount,
        "optionCheck": _vm.optionCheck,
        "show": _vm.show,
        "productShow": _vm.productShow,
        "adjustSame": _vm.adjustSame,
        "pAIndex": pA,
        "aSameCheck": _vm.aSameCheck,
        "paAdjusts": _vm.adjusts,
        "menuJson": _vm.menuJson,
        "layout": "line",
        "clickProduct": _vm.clickProduct
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4794202a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/MutiProduct.vue
// module id = 2401
// module chunks = 1